import React from "react";
import { LocalPreview } from "../localPreview";
import { IRawStyle, IStyle } from "@fluentui/react";


export const localPreviewTrampoline = (mobileView: boolean, doNotShow?: boolean, styles?: IRawStyle): JSX.Element | undefined => {
    if (doNotShow) {
        return undefined;
    }

    return <LocalPreview
        mobileView={mobileView}
        styles={styles ?? {}}
    />;
};

export const cameraPermissionGrantedTrampoline = (
    cameraPermissionGranted: boolean | undefined,
    videoState?: PermissionState | 'unsupported' | undefined
): boolean | undefined => {
    return videoState && videoState !== 'unsupported' ? videoState === 'granted' : cameraPermissionGranted;

    return cameraPermissionGranted;
};

export const micPermissionGrantedTrampoline = (
    microphonePermissionGranted: boolean | undefined,
    audioState?: PermissionState | 'unsupported' | undefined
): boolean | undefined => {
    return audioState && audioState !== 'unsupported' ? audioState === 'granted' : microphonePermissionGranted;

    return microphonePermissionGranted;
};




